import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
export function Countdown() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    v: hours,
    l: "Hours"
  }, {
    v: minutes,
    l: "Min"
  }, {
    v: seconds,
    l: "Sec"
  }];
  return <div className="text-center" role="timer" aria-live="off" data-id="element-18" data-mp="3q0vnamajrtmu">
      <p className="flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wider text-navy" data-id="element-19" data-mp="3c1vzthyrtks9">
        <ClockIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-20" data-mp="3h0ph7lh6hvxp" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2" data-id="element-21" data-mp="324hvuhu1aogu">
        {units.map((u, i) => <React.Fragment key={u.l} data-id="element-22" data-mp="371zwlkxwdxdr" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-23" data-mp="3731heh4pty8o">
              <span className="flex h-[70px] w-[70px] items-center justify-center rounded-xl bg-navy font-serif text-4xl font-extrabold tabular-nums text-white md:h-20 md:w-20 md:text-[44px]" data-id="element-24" data-mp="10c3f3m387q20">
                {u.v}
              </span>
              <span className="mt-1.5 text-[11px] font-bold uppercase tracking-wider text-ink-muted" data-id="element-25" data-mp="xzbz7tiz49lk">{u.l}</span>
            </div>
            {i < units.length - 1 && <span className="pt-4 text-3xl font-black text-navy" data-id="element-26" data-mp="17rhouwlr6exl">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}